import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name CoreBTC CRM 配置
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // CoreBTC 主题色（与 UI 保持一致）
  colorPrimary: '#2563EB',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'CoreBTC CRM',
  pwa: true,
  logo: '/logo.svg',
  iconfontUrl: '',
  token: {
    // 自定义主题
    sider: {
      colorMenuBackground: '#fff',
      colorTextMenu: '#000',
      colorTextMenuSelected: '#2563EB',
      colorBgMenuItemSelected: 'rgba(37, 99, 235, 0.1)',
    },
  },
};

export default Settings;
